import { Component } from "@angular/core";
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
    selector: 'app-session-expired',
    templateUrl: './session-expired.component.html'
  })
  export class SessionExpiredComponent {
    constructor(private liveAnnouncer: LiveAnnouncer){
      this.liveAnnouncer.announce('Session Expired');
    }
  }